module.exports = __webpack_public_path__ + "img/icon-our-marketing.ec15ebd1.png";